module.exports = __webpack_public_path__ + "img/PorscheCarrera.729ddaf6.jpg";